module.exports = __webpack_public_path__ + "17da490ff216b81d6e263dbb28a1a6d2.svg";